<mat-tab-group backgroundColor="primary">
  @if ((settingsPreferences$ | async).length) {
    <mat-tab label="Preferences" i18n-label >
      <div class="tab flex flex-row flex-wrap gap-2">
        @for (definition of settingsPreferences$ | async; track definition) {
          <div class="control">
            <app-setting-control [setting]="definition"></app-setting-control>
          </div>
        }
      </div>
    </mat-tab>
  }
  @if ((settingsDefaults$ | async).length) {
    <mat-tab label="Shipment Defaults" i18n-label >
      <div class="tab flex flex-row flex-wrap gap-2">
        @for (definition of settingsDefaults$ | async; track definition) {
          <div class="control">
            <app-setting-control [setting]="definition"></app-setting-control>
          </div>
        }
      </div>
    </mat-tab>
  }
</mat-tab-group>
